import { nanoid } from "@reduxjs/toolkit";
import { api } from "../../app/api";

export interface TesSalaryComponentFilters {
  tesId: string;
  date: string;
  // If not given, defaults to hourly
  salaryType?: string;
}

export interface SalaryComponent {
  code: string; // enum?
  allowsZero: boolean;
  isPartOfBaseSalary: boolean;
  infoText?: string;
}

export const tesSalaryComponents = async (
  filters: TesSalaryComponentFilters,
) => {
  const res = await api.get<SalaryComponent[]>(
    "/projections/qry/tesSalaryComponents",
    {
      requestId: nanoid(),
      queryParams: {
        ...filters,
      },
      auth: true,
    },
  );
  return res.data;
};
